import React, { useState, useEffect } from "react";
import { BsBriefcase } from "react-icons/bs";
import { MdOutlineTheaterComedy, MdFestival, MdOutlineSportsBaseball, MdFamilyRestroom, MdOutlineDiscount, MdOutlineHealthAndSafety } from "react-icons/md";
import { IoSchoolSharp, IoFastFoodOutline } from "react-icons/io5";
import { RxScissors } from "react-icons/rx";
import { GiFoodTruck, GiGuitar, GiEmbrassedEnergy, GiSaxophone } from "react-icons/gi";
import { CiMusicNote1 } from "react-icons/ci";
import { TbMoodKid } from "react-icons/tb";
import { FaBasketShopping } from "react-icons/fa6";
import axios from 'axios';
import { CloudUpload as CloudUploadIcon } from '@material-ui/icons';
import { IconButton, Box, Modal, TextField, Button, Input, Typography, MenuItem, Select, InputLabel, FormControl, Checkbox, FormControlLabel } from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import { BiGame } from "react-icons/bi";
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import './EventModal.css';
import { FaChalkboardTeacher, FaHandsHelping } from "react-icons/fa";

// Categories with icons
export const categories = {
  "Business": {
    icon: <BsBriefcase />,
    color: "#0077b6",
  },
  "Carnival": {
    icon: <GiEmbrassedEnergy />,
    color: "#e67e22",
  },
  "Class": {
    icon: <FaChalkboardTeacher />,
    color: "#8e44ad",
  },
  "Comedy": {
    icon: <MdOutlineTheaterComedy />,
    color: "#e74c3c",
  },
  "Concert": {
    icon: <GiSaxophone />,
    color: "#9b59b6",
  },
  "Crafts": {
    icon: <RxScissors />,
    color: "#543933",
  },
  "Education": {
    icon: <IoSchoolSharp />,
    color: "#014375",
  },
  "Family Fun": {
    icon: <MdFamilyRestroom />,
    color: "#f1c40f",
  },
  "Festival": {
    icon: <MdFestival />,
    color: "#2ecc71",
  },
  "Food": {
    icon: <IoFastFoodOutline />,
    color: "#e67e22",
  },
  "Food Truck": {
    icon: <GiFoodTruck />,
    color: "#16a085",
  },
  "Game": {
    icon: <BiGame />,
    color: "#e70c3c",
  },
  "Health and Wellness": {
    icon: <MdOutlineHealthAndSafety />,
    color: "#fe0e0a",
  },
  "Kids": {
    icon: <TbMoodKid />,
    color: "#00bb17",
  },
  "Live Music": {
    icon: <GiGuitar />,
    color: "#c0392b",
  },
  "Market": {
    icon: <FaBasketShopping />,
    color: "#d35400",
  },
  "Music": {
    icon: <CiMusicNote1 />,
    color: "#2ecc71",
  },
  "Promotion": {
    icon: <MdOutlineDiscount />,
    color: "#4607fa",
  },
  "Sports": {
    icon: <MdOutlineSportsBaseball />,
    color: "#e74c3c",
  },
  "Support": {
    icon: <FaHandsHelping />,
    color: "#07b4eb",
  }
};

const style1 = {
  position: "absolute",
  top: "5%",
  left: "50%",
  transform: "translateX(-50%)",
  width: "90%",
  maxWidth: 370,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
};
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function EventModal({ modalData1, onSave, onClose, onDelete, citylist }) {
  const [title1, setTitle1] = useState("");
  const [description1, setDescription1] = useState("");
  const theme = useTheme();
  const [start1, setStart1] = useState("");
  const [end1, setEnd1] = useState("");
  const [location1, setLocation1] = useState("");
  const [address1, setAddress1] = useState("");
  const [cimage1, setCimage1] = useState("");
  const [link1, setLink1] = useState("");
  const [selectedCategory1, setSelectedCategory1] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  const [rsvp1, setRsvp1] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [image1, setImage1] = useState(null);
  useEffect(() => {
    if (modalData1.visible) {
      // console.log(citylist);
      setTitle1(modalData1.isEdit ? modalData1.title : "");
      setDescription1(modalData1.isEdit ? modalData1.description : "");
      setStart1(moment(modalData1.start).format("YYYY-MM-DDTHH:mm"));
      setEnd1(moment(modalData1.end).format("YYYY-MM-DDTHH:mm"));
      setLocation1(modalData1.location || '');
      setAddress1(modalData1.address || '');
      setCimage1(modalData1.cimage || '');
      setLink1(modalData1.link || '');
      setSelectedCategory1(modalData1.category || []);
      setSelectedCity(modalData1?.cities || '');
      setRsvp1(modalData1.rsvp || false);

    }
  }, [modalData1]);

  const handleImageUpload = async () => {
    if (!image1) return;

    const formData = new FormData();
    formData.append('file', image1);
    formData.append('upload_preset', process.env.REACT_APP_IMAGE_UPLOAD_PRESET);
    formData.append('cloud_name', process.env.REACT_APP_IMAGE_UPLOAD_CLOUD);

    try {
      const response = await axios.post(process.env.REACT_APP_MEDIA_UPLOAD_URL, formData);
      setCimage1(response.data.secure_url);
    } catch (error) {
      console.error('Error uploading image:', error);
    }
  };
  function getStyles(name, personName, theme) {
    return {
      fontWeight: personName.includes(name)
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
    };
  }
  const handleSave = () => {
    if (title1 && start1 && end1 && selectedCategory1.length && description1 && selectedCity) {
      onSave({
        scheduleId: modalData1.scheduleId || '',
        userId: localStorage.getItem('userId'),
        title: title1,
        location: location1,
        address: address1,
        cimage: cimage1,
        description: description1,
        start: new Date(start1).toISOString(),
        end: new Date(end1).toISOString(),
        link: link1,
        selectedCategory: selectedCategory1,
        cities: selectedCity,
        rsvp: rsvp1,
      });
    } else {
      toast('Please fill out all required fields.');
    }
  };

  const handleDelete = () => {
    if (modalData1.scheduleId) {
      onDelete(modalData1.scheduleId);
    }
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };


  const handleChange = (event) => {
    setSelectedCategory1(event.target.value);
  };

  const handleCityChange = (event) => {
    setSelectedCity(event.target.value)
    // const {
    //   target: { value },
    // } = event;
    // setSelectedCities1(typeof value === 'string' ? value.split(',') : value);
  };

  const check_rsvp = () => {
    setRsvp1(!rsvp1);
  };

  return (
    <Modal
      open={modalData1.visible}
      onClose={onClose}
      aria-labelledby="event-input-modal"
      aria-describedby="event-input-modal-description"
      style={{
        // display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto',
        height: '95vh',
      }}
    >
      <Box sx={style1}>
        <Typography variant="h6" mb={2}>
          {modalData1.isEdit ? "Edit Event" : "Create Event"}
        </Typography>

        <TextField fullWidth label="Title" value={title1} onChange={(e) => setTitle1(e.target.value)} margin="normal" required />
        <TextField fullWidth label="Location" value={location1} onChange={(e) => setLocation1(e.target.value)} margin="normal" />
        <TextField fullWidth label="Address" value={address1} onChange={(e) => setAddress1(e.target.value)} margin="normal" />
        {/* 
        <div className="city-selector">
          <select
            id="city-select"
            value={selectedCity}
            onChange={handleCityChange}
            className="city-select"
          >
            {citylist.map((city) => (
              <option key={city._id} value={city._id}>
                {city.cityname}
              </option>
            ))}
          </select>

        </div> */}
        <FormControl fullWidth>
          <InputLabel id="city-select-label">Select City</InputLabel>
          <Select
            labelId="city-select-label"
            id="city-select"
            value={selectedCity}
            onChange={handleCityChange}
            label="Select City"
            MenuProps={{
              PaperProps: {
                style: {
                  // maxHeight: 200, // Set a max height for the dropdown
                  width: 100, // Set the width of the dropdown
                },
              },
            }}
            renderValue={(selected) =>
              citylist.find(city => city._id === selected)?.cityname || ''
            }
          >
            {citylist.map((city) => (
              <MenuItem key={city._id} value={city._id} >
                <div style={{ Width: '100%', display: 'flex', alignContent:'center', margin:'0px 3rem' }}>
                  <Checkbox checked={selectedCity === city._id} />
                  <Typography variant="body1" style={{ marginLeft: '1rem' }}>
                    {city.cityname}
                  </Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display="flex" alignItems="center" marginY={2}>
          <Input type="file" onChange={(e) => setImage1(e.target.files[0])} endAdornment={
            <IconButton onClick={handleImageUpload}>
              <CloudUploadIcon />
            </IconButton>
          } />
          {cimage1 && <img src={cimage1} alt="Uploaded" style={{ width: '150px' }} />}
        </Box>

        <TextField fullWidth type="datetime-local" label="Start Time" value={start1} onChange={(e) => setStart1(e.target.value)} margin="normal" InputLabelProps={{ shrink: true }} />
        <TextField fullWidth type="datetime-local" label="End Time" value={end1} onChange={(e) => setEnd1(e.target.value)} margin="normal" InputLabelProps={{ shrink: true }} />

        <FormControlLabel control={<Checkbox checked={rsvp1} onChange={check_rsvp} />} label="RSVP" />

        <TextField fullWidth label="Description" value={description1} onChange={(e) => setDescription1(e.target.value)} multiline rows={3} margin="normal" required />
        <TextField fullWidth label="Link" value={link1} onChange={(e) => setLink1(e.target.value)} margin="normal" />

        <FormControl fullWidth margin="normal" sx={{ display: 'flex' }}>
          <InputLabel id="category-select-label">Select categories</InputLabel>
          <Select
            labelId="category-select-label"
            multiple
            value={selectedCategory1}
            onChange={handleChange}
            renderValue={(selected) => selected.join(", ")}
            // sx={{ width: '200px' }} // Set the width of the Select
            MenuProps={{
              PaperProps: {
                style: {
                  // maxHeight: 200, // Set a max height for the dropdown
                  width: 200, // Set the width of the dropdown
                },
              },
            }}
          >
            {Object.entries(categories).map(([category, { icon }]) => (
              <MenuItem
                key={category}
                value={category}
                sx={{ display: 'column', alignItems: 'center' }} // Set flex layout for MenuItem
              >
                <div style={{ display: 'flex', width: '180px' }}>
                  <Checkbox checked={selectedCategory1.indexOf(category) > -1} />
                  <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px' }}>
                    {icon}
                    <Typography variant="body1" style={{ marginLeft: '5px' }}>{category}</Typography>
                  </div>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>


        <Box mt={2} display="flex" justifyContent="space-between">
          <Button variant="contained" onClick={handleSave} color="primary">
            {modalData1.isEdit ? 'Update' : 'Save'}
          </Button>
          {modalData1.isEdit && (
            <Button variant="contained" onClick={handleDelete} color="error">Delete</Button>
          )}
          <Button variant="outlined" onClick={onClose} color="secondary">Cancel</Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default EventModal;
